import { render, staticRenderFns } from "./FormConfirm.vue?vue&type=template&id=50e81460&scoped=true&"
import script from "./FormConfirm.vue?vue&type=script&lang=js&"
export * from "./FormConfirm.vue?vue&type=script&lang=js&"
import style0 from "./FormConfirm.vue?vue&type=style&index=0&id=50e81460&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e81460",
  null
  
)

export default component.exports